<template>
    <div class="mt-6">
        <div class="row">
            <div class="col">
                <div class="sau-bx bx-pad text-center" v-if="status.power">
                    <div class="sau-status-box" :class="status.class">
                        <div class="sau-i-circle md" :class="status.class">
                            <i class="icon-sau-cloud md white"></i>
                        </div>
                        <p class="sau-font sm " :class="status.textClass">{{ status.type }}</p>
                        <h3>{{ status.description }}</h3>
                        <p>Status Last Checked: {{ new Date() | moment("dddd, MMMM Do YYYY") }}</p>
                        <a href="#" class="btn" :class="status.btnClass" @click.prevent="actionSupport">Contact support</a>
                    </div>
                </div>
                <div class="sau-bx bx-pad text-center" v-else-if="gotData && !status.power">
                    <h3>There was an issue retrieving the current status of your server</h3>
                    <a href="#" class="btn btn-danger" :class="status.btnClass" @click.prevent="actionSupport">Contact support</a>
                </div>
                <div class="text-center" v-else>
                    <sau-loading>
                        <template slot="message">Fetching Current Status</template>
                    </sau-loading>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    data() {
        return {
            status: {
                class: '',
                description: '',
                textClass: '',
                btnClass: '',
                power: ''
            },
        }
    },
    created() {
        this.startApp();
    },
    methods: {
        startApp() {
            this.getDeviceStatus().then(response => {
                if(response.data) {
                    this.status.power = response.data.powerState ? response.data.powerState == 'poweredOn' ? 'on' : 'off' : 'unreachable';
                    this.setDetails();
                }
            });
        },
        setDetails() {
            switch(this.status.power) {
                case 'on':
                    this.status.class = 'success';
                    this.status.description = 'Your Cloud Server is currently powered on.';
                    this.status.type = 'Active';
                    this.status.textClass = 'text-success';
                    this.status.btnClass = 'btn-success';
                        break;
                case 'off':
                    this.status.class = 'danger';
                    this.status.description = 'Your Cloud Server is either off or has shut down.';
                    this.status.type = 'Disabled';
                    this.status.textClass = 'text-danger';
                    this.status.btnClass = 'btn-danger';
                        break;
                case 'unreachable':
                    this.status.class = 'danger';
                    this.status.description = 'Your Cloud Server is currently unreachable. Try again shortly, if no response is received please open a support ticket.';
                    this.status.type = 'Unreachable';
                    this.status.textClass = 'text-danger';
                    this.status.btnClass = 'btn-danger';
                        break;
                default:
                    this.status.class = 'danger';
                    this.status.description = 'Your Cloud Server server came back with a status of ' + this.status.power;
                    this.status.type = 'Unknown';
                    this.status.textClass = 'text-danger';
                    this.status.btnClass = 'btn-danger';
                        break;
            }
        },
    }
}
</script>
<style>
</style>
